import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import CardPayment from '../CardPayment/CardPayment';
import creditCardImg from '../../img/credit-card.png';
//import pseImg from '../../img/pse.png';
import PsePayment from '../PsePayment/PsePayment';
import DescuentoNomina from '../DescuentoNomina/DescuentoNomina';

const select = state => {
  return {
    user: state.auth.user,
    userId: state.auth.userId
  };
};

class ConnectedShoppingCartPayment extends Component {

  constructor(props) {
    super(props);

    this.state = {
      paymentType: 0,
      paymentDone: false
    };

  }

  handlePaymentChange(paymentType) {
    this.setState({ paymentType });
  }

  render() {
    const { paymentDone, paymentType } = this.state;
    const {
      products,
      deliveryInfo,
      returnToCart,
      totalAmount
    } = this.props;

    if (paymentDone) {
      return (
        <div>
          <h2 style={{ color: '#290044', textAlign: 'center', margin: '40px 0' }}>
            Recibimos tu pago por un valor de COP { totalAmount }.
          </h2>
        </div>
      );
    }

    const choosePaymentType = (
      <div className="center">
        <h4>Elige el método de pago</h4>

        <Row className="justify-content-center">
          <Col md={6}>
            <div className="paymentTypeCard" onClick={() => this.handlePaymentChange(1)}>
              <img src={creditCardImg} alt="Tarjeta de crédito" style={{ height: '50px' }} aria-hidden="true" />
              <h5>Tarjeta de crédito</h5>
            </div>
          </Col>
        </Row>
        {/* <Row className="justify-content-center">
          <Col md={6}>
            <div className="paymentTypeCard" onClick={() => this.handlePaymentChange(2)}>
              <img src={pseImg} alt="Débito bancario (PSE)" style={{ height: '50px' }} aria-hidden="true" />
              <h5>Débito bancario (PSE)</h5>
            </div>
          </Col>
        </Row> */}
        <Row className="justify-content-center">
          <Col md={6}>
            <div className="paymentTypeCard" onClick={() => this.handlePaymentChange(3)}>
              <i className="fas fa-file-invoice" style={{ fontSize: '50px', color: '#072450' }} />
              <h5>Descuento de nómina</h5>
            </div>
          </Col>
        </Row>
      </div>
    );

    return (
      <Container style={{ marginTop: '100px', marginBottom: '100px' }}>
        <div className="center payment-options">
          <span style={{ float: 'left' }}>
            {
              paymentType === 0 ?
              <i className="fas fa-arrow-alt-circle-left" onClick={() => returnToCart()} /> : 
              <i className="fas fa-arrow-alt-circle-left" onClick={() => this.handlePaymentChange(0)} />
            }
          </span>
          <br /><br />
        </div>

        <div id="paymentScreen">
          {
            paymentType === 0 ? choosePaymentType :
            paymentType === 1 ?
            <CardPayment
              amount={totalAmount}
              products={products}
              deliveryInfo={deliveryInfo}
              paymentType={'CART_PAYMENT'}
            /> :
            paymentType === 2 ?
            <PsePayment
              amount={totalAmount}
              products={products}
              deliveryInfo={deliveryInfo}
              paymentType={'CART_PAYMENT'}
            /> :
            paymentType === 3 ?
            <DescuentoNomina
              amount={totalAmount}
              products={products}
              deliveryInfo={deliveryInfo}
              paymentType={'CART_PAYMENT'}
            /> :
            null
          }
        </div>
      </Container>
    );
  }
}

const ShoppingCartPayment = connect(select)(ConnectedShoppingCartPayment);

export default withRouter(ShoppingCartPayment);
